<template>
  <div class="ui-data-table">
    <table class="ui-data-table__table">
      <thead>
        <tr>
          <th
            v-for="column in columns"
            :key="column.key"
            scope="col"
            :class="{ 'is-end': column.align === 'end' }"
          >
            {{ column.label }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(item, index) in items" :key="String(item[rowKey])">
          <td
            v-for="column in columns"
            :key="column.key"
            :class="{ 'is-end': column.align === 'end', 'is-nowrap': column.nowrap }"
          >
            <slot :name="`cell-${column.key}`" :item="item" :index="index">
              {{ item[column.key] }}
            </slot>
          </td>
        </tr>
      </tbody>
    </table>

    <ul class="ui-data-table__cards">
      <li v-for="(item, index) in items" :key="String(item[rowKey])" class="ui-data-table__card">
        <slot name="card" :item="item" :index="index" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts" generic="T extends Record<string, any>">
export interface UiDataTableColumn {
  key: string;
  label: string;
  align?: "start" | "end";
  nowrap?: boolean;
}

withDefaults(
  defineProps<{
    columns: UiDataTableColumn[];
    items: T[];
    rowKey?: string;
  }>(),
  {
    rowKey: "id",
  },
);
</script>
